import { Component } from 'react'
import PropTypes from 'prop-types'

class EveServerManager extends Component {
    constructor(props) {
        super(props)

        window.generateServerObject = this.generateServerObject
        window.addServers = this.addServers
        window.updateEnabledServers = this.updateEnabledServers
    }

    shouldComponentUpdate() {
        return false
    }

    // Generate a server object to allow us to easily access information
    generateServerObject = (server, ssoUrl, slingerUrl) => ({
        name: server.displayName,
        shortName: server.name,
        enabled: true,
        websiteUrl:
            server.name === 'tq'
                ? `https://launcher.${this.props.serviceDomains.production}`
                : `https://launcher.${this.props.serviceDomains.testing}`,
        sso: {
            url: ssoUrl,
            slinger: slingerUrl,
        },
        status: 'offline',
        statusLabel: 'Offline',
        showPlayers: false,
        playButton: true,
        numPlayers: 0,
        profiles: ['Default'],
    })

    // Function to add server list from backend
    addServers = (servers) => {
        try {
            let server
            let ssoUrl
            let tokenService
            const serverList = {}

            // Run through the json object of servers
            for (let i = 0; i < servers.length; i++) {
                server = servers[i]

                // Handle unique cases (TQ and multi), as their SSO paths do not
                // conform to the other servers.
                switch (server.name) {
                    case 'tq':
                        ssoUrl = `login.${this.props.serviceDomains.production}`
                        tokenService = this.props.tokenServices.production
                        break
                    case 'mp':
                        ssoUrl = `multilogin.${this.props.serviceDomains.testing}`
                        tokenService = this.props.tokenServices.testing.replace('{server}', 'multi')
                        break
                    default:
                        ssoUrl = `${server.name}login.${this.props.serviceDomains.testing}`
                        tokenService = this.props.tokenServices.testing.replace(
                            '{server}',
                            server.name,
                        )
                        break
                }

                // Generate a server object
                const serverObject = window.generateServerObject(server, ssoUrl, tokenService)

                // Add the server to the server list
                serverList[server.name] = serverObject
            }

            // Update the server list in store
            this.props.setServerList(serverList)

            const hash = window.location.hash

            let activeServerName
            if (hash !== '') {
                // Find matches for hash that's passed along
                const serverHash = hash.match(/(?:server[:])([\w]+)/i)

                // If we find match for a server we update the active server
                if (
                    serverHash &&
                    serverHash[1] !== undefined &&
                    serverList[serverHash[1]] !== undefined
                ) {
                    // Get the server shortname
                    activeServerName = serverList[serverHash[1]].shortName
                }
            } else if (serverList.tq === undefined && Object.keys(serverList).length > 0) {
                activeServerName = serverList[Object.keys(serverList)[0]].shortName
            } else if (serverList.tq !== undefined) {
                activeServerName = 'tq'
            }

            if (activeServerName !== undefined) {
                this.props.setActiveServer(activeServerName)
            }

            // Once we have changed a server we should
            // submit a new token to the backend
            window.setToken()
        } catch (error) {
            console.info(`Encountered error while running addServers: ${error.message}`, error)
        }
    }

    // Function to update enabled servers
    updateEnabledServers = (enabledServers) => {
        try {
            // Update what servers are enabled
            this.props.setEnabledServers(enabledServers)
        } catch (error) {
            console.info(`Encountered error while running updateEnabledServers: ${error.message}`)
        }
    }

    render() {
        return null
    }
}

EveServerManager.propTypes = {
    serviceDomains: PropTypes.shape({
        testing: PropTypes.string,
        production: PropTypes.string,
    }),
    tokenServices: PropTypes.shape({
        testing: PropTypes.string,
        production: PropTypes.string,
    }),
    setEnabledServers: PropTypes.func,
    setServerList: PropTypes.func,
    setActiveServer: PropTypes.func,
}

export default EveServerManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/EveServerManager/component.js